/* NAROVELLA — Theme JavaScript */
(function(){
  'use strict';

  /* ── Utility ── */
  function formatMoney(cents){
    var fmt = window.Sybonel.money_format || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{amount\}\}/g, amount).replace(/\{\{amount_no_decimals\}\}/g, Math.round(cents/100));
  }

  /* ── Header scroll ── */
  var header = document.querySelector('.header-wrapper');
  if(header){
    function checkScroll(){
      if(window.scrollY > 40 || !document.body.classList.contains('template-index')){
        header.classList.add('header-wrapper--solid');
      } else {
        header.classList.remove('header-wrapper--solid');
      }
    }
    checkScroll();
    window.addEventListener('scroll', checkScroll, {passive:true});
  }

  /* ── Mobile menu ── */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var mobileMenu = document.querySelector('.mobile-menu');
  if(menuToggle && mobileMenu){
    menuToggle.addEventListener('click', function(){ mobileMenu.classList.add('is-open'); });
    if(menuClose) menuClose.addEventListener('click', function(){ mobileMenu.classList.remove('is-open'); });
    mobileMenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ mobileMenu.classList.remove('is-open'); }); });
  }

  /* ── Cart Drawer ── */
  var backdrop = document.querySelector('.cart-backdrop');
  var drawer = document.querySelector('.cart-drawer');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCart(){ if(backdrop) backdrop.classList.add('is-open'); if(drawer) drawer.classList.add('is-open'); document.body.style.overflow='hidden'; }
  function closeCart(){ if(backdrop) backdrop.classList.remove('is-open'); if(drawer) drawer.classList.remove('is-open'); document.body.style.overflow=''; }

  if(backdrop) backdrop.addEventListener('click', closeCart);
  document.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeCart); });
  document.querySelectorAll('[data-cart-open]').forEach(function(el){ el.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });

  function updateCartCount(count){
    cartCountEls.forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart){
    var items = document.querySelector('.cart-drawer__items');
    var footer = document.querySelector('.cart-drawer__footer');
    var countLabel = document.getElementById('CartDrawerCount');
    if(!items) return;

    if(countLabel) countLabel.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
    updateCartCount(cart.item_count);

    if(cart.items.length === 0){
      items.innerHTML = '<div class="cart-empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4B896" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><p class="font-display" style="font-size:1.125rem;color:#1C1410">Your bag is empty</p><p class="font-body" style="font-size:.875rem;color:#6B5B4E">Discover our collection below.</p><a href="/collections/all" class="btn-cognac" style="margin-top:.5rem">Shop Now</a></div>';
      if(footer) footer.style.display = 'none';
      return;
    }

    if(footer) footer.style.display = 'block';
    var html = '';
    cart.items.forEach(function(item){
      html += '<div class="cart-item" data-key="'+item.key+'">';
      html += '<div class="cart-item__image"><a href="'+item.url+'"><img src="'+(item.image ? item.image.replace(/(\.[^.]+)$/, '_160x160$1') : '')+ '" alt="'+item.title+'"></a></div>';
      html += '<div class="cart-item__info"><div class="flex justify-between items-start"><div><p class="cart-item__title">'+item.product_title+'</p><p class="cart-item__variant">'+item.variant_title+'</p></div>';
      html += '<button class="cart-remove" data-key="'+item.key+'" style="color:#6B5B4E;cursor:pointer;padding:2px" aria-label="Remove"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>';
      html += '<div class="cart-item__bottom"><div class="qty-control"><button data-qty-minus data-key="'+item.key+'"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button><span>'+item.quantity+'</span><button data-qty-plus data-key="'+item.key+'"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></div>';
      html += '<span class="cart-item__price">'+formatMoney(item.final_line_price)+'</span></div></div></div>';
    });
    items.innerHTML = html;

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* Bind quantity/remove buttons */
    items.querySelectorAll('.cart-remove').forEach(function(btn){
      btn.addEventListener('click', function(){ changeCart(btn.dataset.key, 0); });
    });
    items.querySelectorAll('[data-qty-minus]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = cart.items.find(function(i){ return i.key === btn.dataset.key; });
        if(item) changeCart(btn.dataset.key, Math.max(0, item.quantity - 1));
      });
    });
    items.querySelectorAll('[data-qty-plus]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = cart.items.find(function(i){ return i.key === btn.dataset.key; });
        if(item) changeCart(btn.dataset.key, item.quantity + 1);
      });
    });
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); return cart; });
  }

  function changeCart(key, qty){
    fetch(window.Sybonel.routes.cart_change_url, {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(function(r){ return r.json(); }).then(function(cart){ renderCart(cart); });
  }

  window.addToCart = function(formData, callback){
    fetch(window.Sybonel.routes.cart_add_url, {
      method:'POST', body: formData
    }).then(function(r){ return r.json(); }).then(function(item){
      fetchCart().then(function(){ openCart(); });
      if(callback) callback(item);
    }).catch(function(e){ console.error('Add to cart error:', e); });
  };

  /* Init cart on load */
  fetchCart();

  /* ── Product page: image gallery ── */
  var mainImage = document.querySelector('[data-product-main-image]');
  var thumbs = document.querySelectorAll('[data-product-thumb]');
  if(mainImage && thumbs.length){
    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        mainImage.src = thumb.dataset.fullSrc;
        mainImage.alt = thumb.alt || '';
        thumbs.forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Product page: Add to Cart form ── */
  var productForm = document.querySelector('[data-product-form]');
  if(productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-btn]');
      var formData = new FormData(productForm);
      btn.disabled = true;
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:6px"><polyline points="20 6 9 17 4 12"/></svg> Added to Bag';
      btn.style.background = '#1C1410';
      window.addToCart(formData, function(){
        setTimeout(function(){
          btn.disabled = false;
          btn.textContent = 'Add to Bag';
          btn.style.background = '';
        }, 2500);
      });
    });
  }

  /* ── Cart page quantity ── */
  document.querySelectorAll('[data-cart-qty-form]').forEach(function(form){
    form.querySelectorAll('[data-page-qty-minus],[data-page-qty-plus]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var input = form.querySelector('[data-qty-input]');
        var val = parseInt(input.value) || 1;
        if(btn.hasAttribute('data-page-qty-minus')) val = Math.max(1, val - 1);
        else val++;
        input.value = val;
        form.submit();
      });
    });
  });

  /* ── Scroll Reveal Animations ── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.15,
      rootMargin: "0px 0px -50px 0px"
    });

    window.initReveal = function() {
      document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
        revealObserver.observe(el);
      });
    };
    window.initReveal();
    document.addEventListener('shopify:section:load', window.initReveal);
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    window.initReveal = function() {
      document.querySelectorAll('.reveal').forEach(function(el) {
        el.classList.add('visible');
      });
    };
    window.initReveal();
    document.addEventListener('shopify:section:load', window.initReveal);
  }

})();
